<template>
    <div class="modal modal-open" id="modal-add-sow-to-deal">
        <div class="modal-overflow">
            <div class="modal-window">
                <button
                    class="btn btn-modal-close"
                    type="button"
                    @click="handleCloseModal"
                >
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row jus-c--space-between">
                        <div class="col-xl-11 col-lg-11 col-md-11">
                            <div class="form-field form-field--text">
                                <label for="sow_title">Title</label>
                                <input
                                    type="text"
                                    id="sow_title"
                                    v-model="sow.title"
                                    name="sow_title"
                                />
                                <!-- <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.title"
                                    >{{ errors.title }}</span
                                > -->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div
                                class="form-field form-field--datepicker"
                                ref="datepicker"
                            >
                                <label for="sow_date"
                                    >Date<span class="red">*</span></label
                                >
                                <input
                                    type="text"
                                    id="sow_date"
                                    v-model="sow.date"
                                    name="sow_date"
                                    @changeDate="onChangeDatePicker"
                                />
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.date"
                                    >{{ errors.date }}</span
                                >
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div
                                class="form-field form-field--datepicker"
                                ref="valid_datepicker"
                            >
                                <label for="sow_date">Valid until</label>
                                <input
                                    type="text"
                                    id="sow_date"
                                    v-model="sow.valid_date"
                                    name="sow_date"
                                    @changeDate="onChangeValidDatePicker"
                                />
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div
                                class="form-field form-field--radiobutton form-field--radiobutton-sow"
                            >
                                <input
                                    type="radio"
                                    id="sow_type_file"
                                    name="type"
                                    :checked="sow.type === 'file'"
                                    @change="onChangeSowType('file')"
                                />
                                <label for="sow_type_file">File</label>
                                <div
                                    class="form-field form-field--file"
                                    ref="filepicker"
                                >
                                    <input
                                        type="file"
                                        id="agreement"
                                        name="agreement"
                                        hidden
                                        ref="fileInput"
                                        @input="pickFile"
                                        @change="pickFile"
                                    />
                                    <button type="button" class="btn btn--file">
                                        File
                                        <i class="icon icon-plus"></i>
                                    </button>
                                    <span
                                        class="filename"
                                        v-if="sow.filename && !sow.file_url"
                                        >{{ sow.filename }}</span
                                    >
                                    <a
                                        target="_blank"
                                        :href="sow.file_url"
                                        style="margin-left: 4px"
                                        class="red filename"
                                        v-if="sow.filename && sow.file_url"
                                        >{{ sow.filename }}</a
                                    >
                                </div>
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.file"
                                    >{{ errors.file }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div
                                class="form-field form-field--radiobutton form-field--radiobutton-sow"
                            >
                                <input
                                    type="radio"
                                    id="sow_type_url"
                                    name="type"
                                    :checked="sow.type === 'url'"
                                    @change="onChangeSowType('url')"
                                />
                                <label for="sow_type_url">URL</label>
                                <div class="form-field form-field--text">
                                    <input
                                        type="text"
                                        id="sow_url"
                                        v-model="sow.url"
                                        name="sow_url"
                                    />
                                </div>
                                <span
                                    @click="openLeadsFolderLink"
                                    style="margin-left: 8px; color: red"
                                    ><i class="icon icon-external-link"></i
                                ></span>
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.url"
                                    >{{ errors.url }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--radiobutton">
                                <input
                                    type="radio"
                                    id="sow_type_none"
                                    name="type"
                                    :checked="sow.type === 'none'"
                                    @change="onChangeSowType('none')"
                                />
                                <label for="sow_type_none"
                                    >I don’t have a signed SOW</label
                                >
                                <span
                                    class="error"
                                    style="left: 0"
                                    v-if="errors.type"
                                    >{{ errors.type }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--textarea">
                                <label for="sow_description">Explanation</label>
                                <textarea
                                    id="sow_description"
                                    v-model="sow.description"
                                    name="sow_description"
                                ></textarea>
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.description"
                                    >{{ errors.description }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row flex jus-c--center">
                        <div class="col-xl-4 col-lg-4">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleSubmit"
                                    type="button"
                                    class="btn"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleCloseModal"
                                    type="button"
                                    class="btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Datepicker } from "vanillajs-datepicker";

export default {
    name: "Add_Sow_To_Deal",
    props: {
        onClose: {
            type: Function,
        },
        onAdd: {
            type: Function,
        },
        onEdit: {
            type: Function,
        },
        deal_id: {
            type: Number,
        },
        editId: {
            type: Number,
        },
        editData: {
            type: Object,
        },
        generated_title: {
            type: String,
        },
        check_sow: {
            type: Boolean,
        },
    },
    mounted() {
        this.initDatePicker();
        this.initValidDatePicker();
        this.initFilePicker();

        console.log("check_sow", this.check_sow);

        if (this.editId) {
            this.sow.title = this.editData.name;
            this.sow.date = this.editData.date;
            this.sow.file = this.editData.file;
            this.sow.type = this.editData.type;
            this.sow.filename = this.editData.file;
            this.sow.description = this.editData.description;
            this.sow.url = this.editData.url;
            this.sow.valid_date = this.editData.valid_date;
            this.sow.file_url = this.editData.file_url;
        } else {
            this.sow.title = this.generated_title;
        }
    },
    data() {
        return {
            sow: {
                type: "",
                title: "",
                date: null,
                valid_date: null,
                file: null,
                description: "",
                filename: "",
                url: "",
                file_url: "",
            },
            errors: {
                //title: null,
                date: null,
                file: null,
                url: null,
                type: null,
                description: null,
            },
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
            },
        };
    },
    methods: {
        handleSubmit() {
            this.validateFields();

            if (
                this.errors.date ||
                this.errors.description ||
                this.errors.file ||
                this.errors.type ||
                this.errors.url
            ) {
                return;
            }

            let formData = new FormData();

            formData.append("name", this.sow.title);
            formData.append("deal_id", this.deal_id);
            formData.append(
                "file",
                this.sow.file === null ? "" : this.sow.file
            );
            formData.append(
                "date",
                this.sow.date === null ? "" : this.sow.date
            );
            formData.append(
                "valid_date",
                this.sow.valid_date === null ? "" : this.sow.valid_date
            );
            formData.append("description", this.sow.description);
            formData.append("url", this.sow.url);
            formData.append("type", this.sow.type);

            if (this.editId) {
                formData.append("id", this.editId);
                if (typeof this.sow.file === "string") {
                    formData.delete("file");
                }
                this.onEdit(formData);
                return;
            }

            this.onAdd(formData);
        },

        handleCloseModal() {
            this.clear();
            this.onClose();
        },

        validateFields() {
            this.errors.date = null;
            //this.errors.title = null;
            this.errors.file = null;
            this.errors.description = null;
            this.errors.type = null;
            this.errors.url = null;
            //this.errors.valid_date = null;

            // if (!this.sow.title) {
            //     this.errors.title = "Required";
            // }

            if (!this.sow.date) {
                this.errors.date = "Required";
            }

            // if (!this.sow.valid_date) {
            //     this.errors.valid_date = "Required";
            // }

            if (!this.sow.type) {
                this.errors.type = "Please select sow type";
            }
            if (this.sow.type === "file" && !this.sow.file) {
                this.errors.file = "File is required";
            }

            if (this.sow.type === "url" && !this.sow.url) {
                this.errors.url = "URL is required";
            }

            if (
                !this.check_sow &&
                this.sow.type === "none" &&
                !this.sow.description
            ) {
                this.errors.description = "Description is required";
            }
        },

        clear() {},

        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        initValidDatePicker() {
            const node__datepicker = this.$refs.valid_datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, {
                    ...this.datepicker_options,
                });
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.sow.date = date;
            }
        },

        onChangeValidDatePicker(e) {
            const date = e.target.value;

            if (date) {
                this.sow.valid_date = date;
            }
        },

        initFilePicker() {
            const inputField = this.$refs.filepicker;

            if (!inputField) {
                return;
            }

            const button = inputField.querySelector("button");
            const input = inputField.querySelector("input");
            const filenameNode = inputField.querySelector("span.filename");

            if (button && input) {
                button.addEventListener("click", () => {
                    input.click();
                });
            }

            input.addEventListener("change", () => {
                let file = input.files;
                if (file && file[0]) {
                    const filename = file[0].name;
                    this.sow.filename = filename;
                    filenameNode.innerHTML = filename;
                    this.sow.file = file[0];
                }
            });
        },
        pickFile() {
            let input = this.$refs.fileInput;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.readAsDataURL(file[0]);
                this.sow.file = file[0];
            }
        },

        onChangeSowType(type = "file") {
            this.sow.type = type;

            if (type === "none" && !this.sow.date) {
                this.sow.date = moment().format("MM/DD/yyyy");
            }
        },

        openLeadsFolderLink() {
            const _leads_folder = this.sow.url;

            var res = _leads_folder
                .toString()
                .match(
                    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
                );
            if (res) {
                window.open(_leads_folder, "_blank");
            }
        },
    },
};
</script>
